import React, {useContext} from "react";
import {UserContext} from "@web/hooks/context";
import {Redirect} from "wouter";

export const RequireAuth = ({allowAnonymous, children}) => {
  const [userId, h, user] = useContext(UserContext);

  if (!userId) {
    return <Redirect to="/login" redirect={location.pathname} />;
  }
  if (!allowAnonymous && user.isAnonymous) {
    return <Redirect to="/login" redirect={location.pathname} />;
  }

  return children;
};
